import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuFloating = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "29 11 55 59",
	fill: "#79FBAF",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M44.5 33C44.5 32.4477 44.9477 32 45.5 32H68.5C69.0523 32 69.5 32.4477 69.5 33C69.5 33.5523 69.0523 34 68.5 34H45.5C44.9477 34 44.5 33.5523 44.5 33ZM44.5 41C44.5 40.4477 44.9477 40 45.5 40H65.5C66.0523 40 66.5 40.4477 66.5 41C66.5 41.5523 66.0523 42 65.5 42H45.5C44.9477 42 44.5 41.5523 44.5 41ZM45.5 48C44.9477 48 44.5 48.4477 44.5 49C44.5 49.5523 44.9477 50 45.5 50H59.5C60.0523 50 60.5 49.5523 60.5 49C60.5 48.4477 60.0523 48 59.5 48H45.5Z"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 29,
		y: 13,
		width: 55,
		height: 55,
		rx: 20,
		stroke: "url(#paint0_linear_9678_20416)",
		fill: "none",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})] }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_9678_20416",
		x1: 56.5,
		y1: 13,
		x2: 56.5,
		y2: 68,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#54866C" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#245060"
		})]
	}) })]
});
export default SvgMenuFloating;
